import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Inbox } from "lucide-react";
import { AuthLayout } from "../../../auth";
import { signOutPatient } from "../../application/portalAccount";
import { clearActivePatientId } from "../../application/portalContext";

/**
 * Signed in with nothing to open.
 *
 * Not a state the product creates any more: erasing an account's last record
 * takes the account and the sign-in with it. This covers the moment between a
 * record going and the token noticing, and anything unforeseen — better an
 * explanation than an empty dashboard.
 */
export default function PortalNoRecordsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const leave = async () => {
    clearActivePatientId();
    await signOutPatient();
    navigate("/portal/login", { replace: true });
  };

  return (
    <AuthLayout
      panelTagline={t("portal.login.panelTagline")}
      panelTitle={t("portal.noRecords.panelTitle", "Your space is here when there is something to see.")}
      colorScheme="portal"
    >
      <div className="space-y-6 text-center">
        <Inbox className="mx-auto h-12 w-12 text-content-tertiary" aria-hidden="true" />
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-content-primary">
            {t("portal.noRecords.title", "There are no panels on this account")}
          </h1>
          <p className="text-sm text-content-tertiary">
            {t(
              "portal.noRecords.body",
              "Your professional will send you a new invitation when there is something to see here.",
            )}
          </p>
        </div>
        <button
          type="button"
          onClick={leave}
          className="rounded-xl px-5 py-2.5 text-sm text-content-secondary hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
        >
          {t("portal.noRecords.signOut", "Sign out")}
        </button>
      </div>
    </AuthLayout>
  );
}
